import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-arror-right-svg',
  template: `
  <svg width="12px" height="8px" viewBox="0 0 12 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Policy_card_auto_paid_992+" transform="translate(-652.000000, -238.000000)" fill="#FFFFFF">
        <g id="details_link" transform="translate(473.000000, 234.000000)">
            <polygon id="keyboard_backspace---material" transform="translate(185.000000, 8.000000) rotate(-180.000000) translate(-185.000000, -8.000000) " points="191 7.344 191 8.656 181.56 8.656 183.944 11.056 183 12 179 8 183 4 183.944 4.944 181.56 7.344"></polygon>
        </g>
    </g>
</g>
</svg>
  `
})
export class ArrorRightSvgComponent {

}
